"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.InputStyled = styled_components_1.default(react_native_1.TextInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 90%;\n    height: 46px;\n    border: 1px solid ", ";\n    border-radius: 3px;\n    padding-left: ", "px;\n"], ["\n    width: 90%;\n    height: 46px;\n    border: 1px solid ", ";\n    border-radius: 3px;\n    padding-left: ", "px;\n"])), function (props) {
  return props.borderColor ? props.borderColor : props.theme.colors.gray;
}, function (props) {
  return props.paddingLeft;
});
exports.InputBox = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n"], ["\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n"])));
exports.ValidationBox = styled_components_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: 5px;\n    width: 10%;\n"], ["\n    padding-left: 5px;\n    width: 10%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;